import React, { useState, useEffect } from "react";
import "./GitHubRepos.css"; // Import custom CSS for styling

function GitHubRepos() {
  const [repos, setRepos] = useState([]);

  useEffect(() => {
    fetch("https://api.github.com/users/balaji0511/repos")
      .then((response) => response.json())
      .then((data) => {
        setRepos(data); // Set the repositories data
      })
      .catch((error) => {
        console.error("Error fetching GitHub repositories:", error);
      });
  }, []);

  return (
    <div className="repo-container">
      {repos.length === 0 ? (
        <p>Loading...</p> // Display while data is loading
      ) : (
        <div className="repo-list">
          {repos.map((repo) => (
            <div className="repo-card" key={repo.id}>
              <a href={repo.html_url} target="_blank" rel="noopener noreferrer">
                <h3>{repo.name}</h3>
                <p>{repo.visibility === "public" ? "Public" : "Private"}</p>
                <p>{repo.language || "No language"}</p>
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default GitHubRepos;
